import { LOGIN_STEPS, OTP_METHODS } from '@/data/Content/Login';
import { combineSX } from '@/utils/combineSX';
import { Switch } from '@/utils/switch';
import { Box, SxProps, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { RegistrationOrigin } from '@/data/Content/Registration';

type Props = {
	step: LOGIN_STEPS;
	otpMethod?: OTP_METHODS;
	showPreviousMethodHint?: boolean;
	maskedPhone?: string | null;
	maskedEmail?: string | null;
	showInDialog?: boolean;
	sx?: SxProps;
	origin?: RegistrationOrigin;
	onToggleBackStep: () => void;
};

export const SingleLoginLessTitle: React.FC<Props> = ({
	step,
	otpMethod,
	showPreviousMethodHint = false,
	maskedPhone,
	maskedEmail,
	showInDialog = false,
	origin = 'unknown',
	sx,
	onToggleBackStep,
}) => (
	<>
		{step !== LOGIN_STEPS.INITIAL_LOGON_ID ? (
			<Box sx={{ width: '100%', marginBottom: '20px' }}>
				<ArrowBackIosIcon
					sx={{ fontSize: '24px', cursor: 'pointer', fill: '#2C2C2C', alignSelf: 'flex-start' }}
					onClick={onToggleBackStep}
				/>
			</Box>
		) : null}
		<Typography
			component={showInDialog ? 'p' : 'h1'}
			sx={combineSX([
				{
					fontSize: (sx as any)?.['fontSize']
						? (sx as any)['fontSize']
						: { md: 'var(--font-size-xl)', xs: 'var(--font-size-lg)' },
					fontWeight: '800',
					letterSpacing: '0px',
					color: '#2C2C2C',
					textTransform: 'uppercase',
					opacity: 1,
					marginBottom:
						step === LOGIN_STEPS.SELECT_OTP_METHOD
							? showPreviousMethodHint
								? '0px'
								: '15px'
							: step === LOGIN_STEPS.INITIAL_LOGON_ID
							? '0px'
							: showInDialog
							? '14px'
							: '15px',
				},
				sx,
			])}
		>
			{Switch(step)
				.case(LOGIN_STEPS.SELECT_OTP_METHOD, () => '¿Cómo quieres ingresar?')
				.case(
					LOGIN_STEPS.LOGIN_OTP,
					() =>
						`Escribe el código de 6 dígitos que enviamos por ${
							otpMethod === OTP_METHODS.SMS
								? `mensaje al teléfono ${maskedPhone}`
								: `correo a ${maskedEmail}`
						}`
				)
				.defaultTo(() =>
					['quick_cart', 'cart'].includes(origin ?? '') ? 'INICIA SESIÓN' : '¡Hola de nuevo!'
				)}
		</Typography>
		{step === LOGIN_STEPS.SELECT_OTP_METHOD && showPreviousMethodHint ? (
			<Typography
				component="p"
				sx={{
					fontSize: showInDialog ? '15px' : 'var(--font-size-sm)',
					fontWeight: 'normal',
					letterSpacing: '0px',
					color: '#2C2C2C',
					opacity: 1,
					mt: '0px !important',
					textTransform: 'none',
					marginBottom: '15px',
				}}
			>
				{'Usamos tu método anterior. Puedes cambiarlo.'}
			</Typography>
		) : null}
		{step === LOGIN_STEPS.INITIAL_LOGON_ID ? (
			<Typography
				component={showInDialog ? 'p' : 'h2'}
				sx={{
					fontSize: showInDialog ? '15px' : 'var(--font-size-sm)',
					fontWeight: 'normal',
					letterSpacing: '0px',
					color: '#2C2C2C',
					opacity: 1,
					mt: '0px !important',
					textTransform: 'none',
					marginBottom: showInDialog ? '15px' : '20px',
				}}
			>
				{['quick_cart', 'cart'].includes(origin ?? '')
					? 'Completa tus datos para ingresar y hacer tu compra'
					: 'Inicia sesión con tu cuenta para continuar'}
			</Typography>
		) : null}
	</>
);
